$(document).on('click', 'article.paid-payment button.edit, article.paid-payment button.update, article.paid-payment button.cancel', (e) => {
  e.preventDefault();

  $(e.currentTarget).closest("article.paid-payment")
    .find('.show-payment, .edit-payment')
    .toggleClass('hide');
});